export default function DeleteDesignIcon() {
  return (
    <svg viewBox="0 0 15.99 15.99" xmlns="https://www.w3.org/2000/svg">
      <path d="M12.21 16H3.14a1.28 1.28 0 0 1-1.28-1.22L1.37 4.32H.16A.16.16 0 0 1 0 4.16v-.64a.64.64 0 0 1 .64-.64H3.2v-1.6A1.28 1.28 0 0 1 4.48 0h6.4a1.28 1.28 0 0 1 1.28 1.28v1.6h2.56a.65.65 0 0 1 .64.64v.64a.16.16 0 0 1-.16.16H14l-.5 10.45A1.27 1.27 0 0 1 12.21 16zM2.81 4.32l.48 10.23h8.77l.49-10.23zm1.83-1.44h6.08V1.44h.16a.16.16 0 0 1-.16-.16v.16H4.64z" />
    </svg>
  );
}
